<template>
	<div class="tvlist">
		<Bannerinner/>
		<div class="titleinfo">
			<h3><a href="/">首页</a><em>></em><router-link :to="{path:'/tv/index.html'}">央视普法</router-link><em>></em><a href="javascript:void(0)" class="changetitle">{{lmname}}</a><em>></em></h3>
			<h2 class="linebox">
				<strong>冠领在央视</strong>
				<em></em>
				<p>律师央视普法&nbsp;&nbsp;&nbsp;&nbsp;美名走进万家</p>
			</h2>
		</div>
		<div class="teamwrap">
			<div class="teambtn cctvbtn">
				<span @click="changeIndex(index,item.xid,item.zmid)" v-for="item,index in navList" :key="item.id" :class="index == currentIndex ? 'active' : ''">{{item.name}}</span>
			</div>
			<div class="teambox">
				
				<div class="teamitem" v-for="item,index in cctvdatas" :key="item.id">
					<router-link class="teaminner" :to="{path:'/tv/'+item.type+'/'+item.id+'.html'}">
						<div class="teamimg"><img :src="item.thumb" alt=""></div>
						<div class="teaminfo">
							<strong>{{item.title}}</strong>
						</div>
					</router-link>
				</div>

			</div>
			<div class="page">
			 <el-pagination
			   background
			   hide-on-single-page
			   :current-page.sync='currentpage'
			   @current-change="getPage"
			   layout="prev, pager, next"
			   prev-text="上一页"
			   next-text="下一页"
			   :page-size="pagesize"
			   :pager-count = pagerCount
			   :total="total">
			 </el-pagination>
			</div>
		</div>
		<div class="honorteam">
			<h3>荣誉律师</h3>
			<ul>
				<li>
					<router-link :to="{path:'/team/v/1.html'}"><img src="../assets/images/zhous.jpg" alt=""></router-link>
				</li>
				<li>
					<router-link :to="{path:'/team/v/9.html'}"><img src="../assets/images/ren.jpg" alt=""></router-link>
				</li>
				<li>
					<router-link :to="{path:'/team/v/33.html'}"><img src="../assets/images/wang.jpg" alt=""></router-link>
				</li>
				<li>
					<router-link :to="{path:'/team/v/3.html'}"><img src="../assets/images/zhang.jpg" alt=""></router-link>
				</li>
				
				</ul>
			<router-link to="/team/index.html" class="morelink">了解更多</router-link>
		</div>
		<div class="hottag">
			<h3>热门标签</h3>
			<ul>
				<li @click="toSearch(item.name)" v-for="item,index in searchKeys" :key="item.id"><a href="">{{item.name}}</a></li>
			</ul>
		</div>
	</div>
</template>

<script>
	import $ from 'jquery'
	import {request} from '../network/request.js'
	import GLOBAL from '../global/global.js'
	import Bannerinner from '@/components/Bannerinner'
	export default{
		name:'Tvcctv',
		components:{
			Bannerinner
		},
		data(){
			return {
				currentIndex:0,
				pagesize:10,
				cctvdatas:[],
				pagerCount:7,
				total:0,
				currentpage:1,
				lmid:48,
				lmname:'法律讲堂',
				zhixing:0,
				brtvlock:0,
				tvname:'cctv',
				xid:0,
				zmid:0,
				navList:[
					{id:0,name:'法律讲堂',xid:48,zmid:71},
					{id:1,name:'共同关注',xid:53,zmid:75},
					{id:2,name:'律师来了',xid:51,zmid:44},
					{id:3,name:'以案说法',xid:52,zmid:68}
				],
				searchKeys:[
					{id:0,name:'房屋征收'},
					{id:1,name:'房屋征收纠纷'},
					{id:2,name:'强制拆除房屋'},
					{id:3,name:'河南拆迁律师'},
					{id:4,name:'行政协议纠纷'},
					{id:5,name:'拆迁补偿'},
					{id:6,name:'江苏拆迁维权'},
					{id:7,name:'江苏拆迁诉讼'},
					{id:8,name:'拆迁补偿安置'},
					{id:9,name:'临沂拆迁诉讼'},
					{id:10,name:'征地补偿协议'},
					{id:11,name:'农村拆迁纠纷'},
					{id:12,name:'新乡拆迁诉讼'},
					{id:13,name:'拆迁补偿诉讼'},
					{id:14,name:'拆迁补偿纠纷'},
					{id:15,name:'行政诉讼律师'}
				]
			}
		},
		methods:{
			toSearch(name){
				this.$router.push({ path:'/search/index.html',query:{'name':encodeURI(name)}})
			},
			changeIndex(index,xid,zmid){
				this.currentIndex = index
				this.xid = xid
				this.zmid = zmid
				this.lmname = this.navList[index].name
				this.currentpage = 1
				this.getCCTVData()
			},
			getCCTVData(){
				let that = this
				request({
					url: '/video/cctv?xid='+that.xid+'&zmid='+that.zmid+'&page=1&page_size=10',
					responseType: 'json',
					transformResponse:[function(data){
						let jsondata = JSON.parse(data)
						// console.log(jsondata);
						if(jsondata['code'] == 200){
							that.cctvdatas = []
							let beforeData = jsondata['data']
							jsondata['data'].forEach(function(value,index,arr){
								if(value['leibie'] == "xinty"){
									value['type'] = 'v'
									if(value['thumb'].length > 100){
										let beforeimg = value['thumb'].split(':')[21];
										value['thumb'] = GLOBAL.httpurl+beforeimg.substr(1,beforeimg.length-4)
									}
								}else if(value['leibie'] == 'zmty'){
									value['type'] = 'm'
									value['thumb'] = 'http://api.guanlingls.com'+value['thumb']
								}
								value['create_time'] = value['create_time'].split(' ')[0]
								that.cctvdatas.push(value)
								
							})
							that.total = jsondata['data'][0]['total']	//总页数
							// console.log(that.anliData)
						}
					}]
				})
			},
			getPage(val){
				let that = this
				request({
					url: '/video/cctv?xid='+that.xid+'&zmid='+that.zmid+'&page='+val+'&page_size=10',
					responseType: 'json',
					transformResponse:[function(data){
						let jsondata = JSON.parse(data)
						// console.log(jsondata);
						if(jsondata['code'] == 200){
							that.cctvdatas = []
							let beforeData = jsondata['data']
							jsondata['data'].forEach(function(value,index,arr){
								if(value['leibie'] == "xinty"){
									value['type'] = 'v'
									if(value['thumb'].length > 100){
										let beforeimg = value['thumb'].split(':')[21];
										value['thumb'] = GLOBAL.httpurl+beforeimg.substr(1,beforeimg.length-4)
									}
								}else if(value['leibie'] == 'zmty'){
									value['type'] = 'm'
									value['thumb'] = 'http://api.guanlingls.com'+value['thumb']
								}
								value['create_time'] = value['create_time'].split(' ')[0]
								that.cctvdatas.push(value)
								
							})
							that.total = jsondata['data'][0]['total']	//总页数
							// console.log(that.anliData)
						}
					}]
				})
			}
		},
		mounted() {
			document.title = '北京冠领律师事务所'
			let name = this.$route.name
			this.xid = 48
			this.zmid = 71
		
			this.getCCTVData()
			
		},
		watch:{
			cctvdatas(){


			}
			
		}
	}
</script>

<style lang="scss" scoped>
.teamwrap{
    background: #fff;
    padding: 0 .2rem;
    overflow: hidden;
    margin-top: .15rem;
    .teambtn{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-top: .3rem;
        span{
            font-size: .26rem;
            padding: .1rem .2rem;
            white-space: nowrap;
            border: 1px solid #eeeeee;
            margin-bottom: .2rem;
            color: #9b9494;
            transition: all .2s linear;
            width: 1.2rem;
            text-align: center;
        }
        span.active{
            background-color: #c21a20;
            color: #fff;
        }
    }
    .teambox{
        overflow: hidden;
        // border-top: 1px solid #eee;
        // border-bottom: 1px solid #eee;
        // padding-top: .4rem;
        margin-top: .15rem;
        display: flex;
        flex-wrap: wrap;
        .teamitem:nth-child(odd){
            margin-right: .3rem;
        }
        .teamitem{
            margin-bottom: .4rem;
            width: 3.4rem;
            .teaminner{
                display: flex;
                flex-wrap: wrap;
                .teamimg{
                    width: 3.4rem;
                    // height: 1.6rem;
                    box-shadow: 0 0 2px #ccc;
                    overflow: hidden;
                    img{
						width: 3.4rem;
						height: 2.2rem;
                        // width: 2.2rem;
                    }
                }
                .teaminfo{
                    width: 100%;
                    strong{
                        display: block;
                        font-size: .28rem;
                        margin-bottom: .05rem;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                        text-align: center;
                        font-size: .26rem;
                        margin-top: .1rem;
                    }


                }
            }
        }

    }
}
.honorteam{
    padding: .6rem .3rem .3rem;
    background: #fff;
    h3{
        font-size: .35rem;
        color: #c21a20;
        border-bottom: 1px solid #eee;
        margin-bottom: .2rem;
        padding-bottom: .1rem;
    }
    ul{
        display: flex;
        justify-content: space-between;
        margin-bottom: .3rem;
        li{
            width: 1.5rem;
            height: 2.14rem;
            img{
                width: 1.5rem;
                height: 2.14rem;
            }
        }
    }
}
.hottag{
    padding: .2rem .3rem .3rem;
    background: #fff;
    border-top: 1px solid #eee;
    h3{
        font-size: .35rem;
        color: #c21a20;
    }
    ul{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        li{
			width: 25%;
            margin-top: .15rem;
            a{
                font-size: .26rem;
            }
        }
    }
}

</style>